import { queryOptions } from '@tanstack/react-query';
import { AUTH_STALE_TIME, authQueryKeys } from '../auth/queryKeys';
import { localizedInputSchema } from '../../i18n/catalogData';
import { fetchPublicTrySchema, fetchScraper, fetchScrapers } from './repository';

export const executionQueryKeys = {
  list: (subject: string) => [...authQueryKeys.subject(subject), 'execution', 'list'] as const,
  detail: (subject: string, sku: string) => [...authQueryKeys.subject(subject), 'execution', 'detail', sku] as const,
};

export const scrapersQueryOptions = (subject: string) =>
  queryOptions({
    queryKey: executionQueryKeys.list(subject),
    queryFn: fetchScrapers,
    staleTime: AUTH_STALE_TIME,
  });

export const scraperQueryOptions = (subject: string, sku: string) =>
  queryOptions({
    queryKey: executionQueryKeys.detail(subject, sku),
    queryFn: () => fetchScraper(sku),
    staleTime: AUTH_STALE_TIME,
  });

export const publicTrySchemaQueryOptions = (sku: string) =>
  queryOptions({
    queryKey: ['public-try-schema', sku] as const,
    queryFn: () => fetchPublicTrySchema(sku),
    // Translated as it is read, so the cache holds the gateway's English.
    select: localizedInputSchema,
    staleTime: 5 * 60 * 1_000,
    retry: false,
    enabled: sku !== '',
  });
